import React from 'react';
import ReactDOM from 'react-dom';
import { ArgoApp } from '@awsscm/argo-core';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

ReactDOM.render(
  <div className="awsui">
    <React.StrictMode>
      <BrowserRouter basename="/assets-inventory">
        <ArgoApp content={<App />} />
      </BrowserRouter>
    </React.StrictMode>
  </div>,
  document.getElementById('root')
);
